import angular from 'angular';
import { MeurhOrganogramaService } from '../organograma.service';
import { Diagram } from '../../../shared/components/dhtmlx-diagram/dhtmlxDiagram';

export class MeurhOrganogramaIndexController {
    static $inject = [
        '$rootScope',
        '$timeout',
        '$state',
        'MeurhOrganogramaService',
        '$element',
        'NewToaster',
    ];

    public vm = this;
    public orgData: any[] = [];
    public modo: 'empresa' | 'departamento' = 'empresa';
    public filtrosVisibilidade = {
        empresa: this.$rootScope.session.entities.empresa.empresa as string,
        estabelecimento: this.$rootScope.session.entities.estabelecimento.estabelecimento as string
    };

    private diagram: any;
    private isLoading: boolean = false;
    private sidebarOpen: boolean = false;

    /** Identifica o carregamento corrente — descarta foto que chega depois de uma troca de modo. */
    private geracao: number = 0;

    /** No aberto na sidebar, para nao pintar nela a foto de um colaborador ja trocado. */
    private sidebarItemId: string | null = null;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            liberadoTela: (param: string) => boolean,
        },
        private $timeout: ng.ITimeoutService,
        public $state: angular.ui.IStateService,
        public MeurhOrganogramaService: MeurhOrganogramaService,
        private $element: JQLite, // para acessar o DOM do componente
        public NewToaster: any,
    ) {}

    $onInit() {
        if (!(!this.$rootScope.soPossuiPonto() &&
            this.$rootScope.liberadoTela('LIBERAR_ORGANOGRAMA') &&
            this.$rootScope.temPermissao('visualizar_funcionarios'))
        ) {
            this.$state.go('dp');
            return;
        }
        this.loadData();
        this.moveDiagram();
    }

    setModo(modo: 'empresa' | 'departamento') {
        this.modo = modo;
        this.loadData();
    }

    loadData() {
        this.isLoading = true;
        this.geracao++;
        const geracaoAtual = this.geracao;

        this.MeurhOrganogramaService.constructors.empresa = this.filtrosVisibilidade.empresa;
        this.MeurhOrganogramaService.getOrganograma(this.modo).then((dados: any) => {
            this.orgData = this.removerOrfaos(this.tratarDados(dados));

            // tratar a existencia de mais de um nó raiz.
            this.orgData = this.tratarNoRaiz(this.orgData);

            // tratar a visualização
            this.ajustarDirecao(this.orgData);

            // tratar o nível
            this.adicionarNivel(this.orgData);

            // tratar a quantidade de filhos
            // this.adicionarQuantidadeFilhos(this.orgData);

            // determinar o open
            this.determinarOpen(this.orgData);

            this.$timeout(() => {
                this.initChart();
                this.carregarFotosVisiveis(geracaoAtual);
            }, 1);
            this.isLoading = false;
        }).catch(error => {
            this.NewToaster.pop({
                type: 'error',
                title: 'Não foi possível carregar o Organograma'
            });
            this.isLoading = false;
        });
    }

    /**
     * Monta os nos sem foto. A foto entra depois, so para quem esta visivel — buscar todas
     * aqui fazia a tela abrir com uma requisicao por colaborador do grupo empresarial.
     */
    tratarDados(dados: Array<any>): any[] {
        return dados.map((item) => {
            const { identificador, gestor, cargo_nome, departamento_nome, identidadecorporativa, gestor_nome, gestor_tipo, nome, tipo, original_id, foto_versao } = item;
            const nomeCurto = identidadecorporativa ? identidadecorporativa : nome;
            return {
                id: identificador,
                parent: gestor,
                cargo_nome,
                departamento_nome,
                gestor_nome,
                gestor_tipo,
                nome: nomeCurto,
                tipo,
                original_id,
                foto_versao,
                photo: null
            };
        });
    }

    removerOrfaos(data: any[]) {
        // 1) Conjunto de todos os IDs válidos
        const ids = new Set(data.map(node => node.id));

        // 2) Para cada nó, verificamos:
        return data.filter(node => {
            // existe um parent que está no conjunto de IDs?
            const temPaiValido = node.parent != null && ids.has(node.parent);

            // há ao menos um nó cuja parent === este node.id?
            const temFilhos = data.some(n => n.parent === node.id);

            // mantém se tiver pai válido ou tiver filhos
            return temPaiValido || temFilhos;
        });
    }

    tratarNoRaiz(data: any[]) {
        // tratar para que somente exista um nó raiz
        const roots = data.filter(node => !node.parent);
        if (roots.length > 1) {
            // criar nó raiz artificial
            data.push(
                {
                    id: 'main',
                    nome: 'Organograma',
                    cargo_nome: 'Raiz',
                    foto_versao: null,
                    photo: ''
                }
            );
            roots.forEach(rootNode => rootNode.parent = 'main');
        }

        return data;
    }

    isLeaf(nodeId: any, data: Array<any>) {
        return !data.some(n => n.parent === nodeId);
    }

    ajustarDirecao(data: any[]) {
        // encontra os filhos diretos do nó atual
        data.forEach(possivelPai => {
            const filhos = data.filter(n => n.parent === possivelPai.id);
            if (filhos.length > 0) {
                // verifica se todos os filhos são folhas (não têm filhos)
                const todosFilhosSaoFolhas = filhos.every(f => this.isLeaf(f.id, data));
                // se todos os filhos forem folhas, define o dir do pai como "vertical"
                if (todosFilhosSaoFolhas) {
                    possivelPai.dir = 'vertical';
                }
            }
        });
    }

    /**
     * Função 1: adiciona a propriedade `level` em cada nó do array.
     * Percorre todos os nós, calcula o nível usando getNodeLevel e seta node.level.
     */
    adicionarNivel(data: any[]): void {
        const memo: Record<string | number, number> = {};

        data.forEach((node) => {
            const nivel = this.getNodeLevel(node, data, memo);
            node.level = nivel;
        });
    }

    /**
     * Função 2: adiciona a propriedade `childrenCount` em cada nó do array.
     * Conta quantos filhos diretos cada nó possui e seta node.childrenCount.
     */
    // adicionarQuantidadeFilhos(data: any[]): void {
    //     data.forEach((node) => {
    //         const qtdFilhos = data.filter((n) => n.parent === node.id).length;
    //         node.childrenCount = qtdFilhos;
    //     });
    // }

    /**
     * Função para calcular recursivamente o nível (depth) de cada nó.
     *    Nível 0 => raiz (parent === null ou não encontrado),
     *    nível 1 => filho da raiz, nível 2 => neto da raiz, etc.
     */
    getNodeLevel(
        node: any,
        data: any[],
        memo: Record<string | number, number> = {}
        ): number {
        // se já foi calculado, retorna do memo
        if (memo[node.id] !== undefined) {
            return memo[node.id];
        }

        // se não tem parent ou parent não está no array, assume nível 0
        if (node.parent == null) {
            memo[node.id] = 0;
            return 0;
        }

        // tenta encontrar o pai no array
        const parentNode = data.find((n) => n.id === node.parent);
        if (!parentNode) {
            // se o parent não existe na lista, trata como raiz
            memo[node.id] = 0;
            return 0;
        }

        // caso contrário, calcula o nível do pai e soma 1
        const parentLevel = this.getNodeLevel(parentNode, data, memo);
        memo[node.id] = parentLevel + 1;
        return parentLevel + 1;
    }

    /**
     * Função 3: determina a propriedade `open` em cada nó, com base em:
     * - Nós de nível 0 abertos
     * - Ou é o último nível de gestão (se todos os filhos do nó forem folhas)
     * - Todos os demais, inicia fechado.
     */
    determinarOpen(data: any[]): void {
        data.forEach((node) => {
            const nivel = node.level ?? 0;
            // const filhos = node.childrenCount ?? 0;
            const paiVertical = node.dir ?? false;

            if (nivel < 1 || paiVertical) {
                node.open = true;
            } else {
                node.open = false;
            }
        });
    }

    initChart() {
        // destrói gráfico anterior
        if (this.diagram && typeof this.diagram.destructor === 'function') {
            this.diagram.destructor();
        }

        const config = this.getTemplateConfig();

        const container = this.$element[0].querySelector('#diagram_container');

        this.diagram = new dhx.Diagram(container, {
            type: 'org',
            defaultShapeType: 'employeeCard',
            scale: config.scale,
            select: true,
            scrollable: true,
        });
        this.diagram.addShape('employeeCard', {
            template: config.template,
            defaults: config.defaults
        });
        this.diagram.events.on('itemClick', (id: string) => {
            this.setSidebar(this.diagram.data.getItem(id));
        });

        // ao abrir/fechar um ramo, so os nos que passaram a aparecer pedem foto
        this.diagram.events.on('afterExpand', (id: string) => {
            this.marcarAberto(id, true);
            this.carregarFotosVisiveis(this.geracao);
        });
        this.diagram.events.on('afterCollapse', (id: string) => {
            this.marcarAberto(id, false);
        });
        this.orgData.forEach(item => {
            item.width = config.defaults.width;
            item.height = config.defaults.height;
        });

        // separar nós e criar links com estilo personalizado
        const nodes = this.orgData.map(({ parent, ...rest }) => rest);
        const links = this.orgData
            .filter(item => item.parent)
            .map(item => ({
                id: `${item.parent}-${item.id}`,
                from: item.parent,
                to: item.id,
                type: 'line',
                strokeType: 'dash',
                stroke: '#00469B'
            }));

        this.diagram.data.parse([...nodes, ...links]);
    }

    getTemplateConfig() {
        const scale = 0.9;
        const defaults = { width: 230, height: 60 };
        const template = ({ photo, nome, cargo_nome }) => `
            <div class='dhx_diagram_template_a_box dhx_diagram_template_a dhx_diagram_template_a--medium'>
                <div class='dhx_diagram_template_a__inside'>
                    ${photo ? `<div class="dhx_fotoColaborador">
                        <img class='dhx_diagram_template_a__picture' src="${photo}" alt="${nome}" />
                    </div>` : ''}
                    <div class='dhx_diagram_template_a__body'>
                        <div class='dhx_diagram_template_a__title'>${nome}</div>
                        <div class='dhx_diagram_template_a__text'>${cargo_nome}</div>
                    </div>
                </div>
            </div>
        `;
        return { template, defaults, scale };
    }

    moveDiagram() {
        const container: any = document.querySelector('.sample__container');

        let isDown = false;
        let startX, startY;
        let scrollLeft, scrollTop;

        container.classList.add('grabbable');

        container.addEventListener('mousedown', (e) => {
            isDown = true;
            container.classList.add('grabbing');
            container.classList.remove('grabbable');
            startX = e.pageX - container.offsetLeft;
            startY = e.pageY - container.offsetTop;
            scrollLeft = container.scrollLeft;
            scrollTop = container.scrollTop;
        });

        container.addEventListener('mouseleave', () => {
            isDown = false;
            container.classList.remove('grabbing');
            container.classList.add('grabbable');
        });

        container.addEventListener('mouseup', () => {
            isDown = false;
            container.classList.remove('grabbing');
            container.classList.add('grabbable');
        });

        container.addEventListener('mousemove', (e) => {
            if (!isDown) {
               return;
            }
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const y = e.pageY - container.offsetTop;
            const walkX = (x - startX) * 1.5;
            const walkY = (y - startY) * 1.5;
            container.scrollLeft = scrollLeft - walkX;
            container.scrollTop = scrollTop - walkY;
        });
    }

    setSidebar(config: any) {
        if (!config?.nome) {
            return;
        }

        this.sidebarItemId = config.id;

        const sideBar = document.getElementById('sidebar_info') as HTMLElement;
        const name = document.querySelector('#name') as HTMLElement;
        const position = document.querySelector('#position') as HTMLElement;
        const photo = document.querySelector('#photo') as HTMLImageElement;

        setTimeout(() => {
            sideBar.style.display = 'flex';
            name.textContent = config.nome;
            position.textContent = config.cargo_nome;
            if (config.photo) {
                photo.style.display = 'block';
                photo.src = config.photo;
                photo.alt = `${config.nome}-${config.cargo_nome}`;
            } else {
                photo.style.display = 'none';

                // no ainda sem foto carregada (ramo fechado, por exemplo): busca sob demanda
                // as duas chamadas caem na mesma promise cacheada do service, entao e uma requisicao so
                if (config.original_id && config.foto_versao !== null) {
                    this.carregarFotoDoNo(this.orgData.find((n) => n.id === config.id), this.geracao);

                    this.MeurhOrganogramaService.getTrabalhadoresFoto(config.original_id, config.foto_versao)
                        .then((url: string | null) => {
                            // o usuario pode ter clicado em outro no enquanto a foto vinha
                            if (!url || this.sidebarItemId !== config.id) {
                                return;
                            }
                            photo.style.display = 'block';
                            photo.src = url;
                            photo.alt = `${config.nome}-${config.cargo_nome}`;
                        });
                }
            }
        }, 0);
    }

    closeSideber() {
        const sideBar = document.getElementById('sidebar_info') as HTMLElement;
        sideBar.style.display = 'none';
    }

    $onDestroy() {
        // cancela as fotos ainda em voo e revoga as object URLs criadas para os nos
        this.MeurhOrganogramaService.limparFotos();

        if (this.diagram && typeof this.diagram.destructor === 'function') {
            this.diagram.destructor();
        }
    }

    /**
     * Nos efetivamente visiveis: raiz, ou cujo pai esta visivel e aberto.
     * E dessa lista que sai a carga de fotos — o resto so carrega quando o ramo abre.
     */
    private nosVisiveis(data: any[]): any[] {
        const porId: { [id: string]: any } = {};
        data.forEach((node) => porId[node.id] = node);

        const memo: { [id: string]: boolean } = {};

        const ehVisivel = (node: any): boolean => {
            if (memo[node.id] !== undefined) {
                return memo[node.id];
            }

            // marcado antes da recursao para nao girar em caso de ciclo inesperado
            memo[node.id] = true;

            const pai = node.parent ? porId[node.parent] : null;
            if (pai) {
                memo[node.id] = !!pai.open && ehVisivel(pai);
            }

            return memo[node.id];
        };

        return data.filter((node) => ehVisivel(node));
    }

    private carregarFotosVisiveis(geracaoAtual: number): void {
        this.nosVisiveis(this.orgData).forEach((node) => this.carregarFotoDoNo(node, geracaoAtual));
    }

    private carregarFotoDoNo(node: any, geracaoAtual: number): void {
        // `foto_versao === null` e o backend dizendo que nao ha foto: nem chega a requisitar.
        // `undefined` significa backend ainda sem o campo — nesse caso busca sem versionar.
        if (!node || node.photo || !node.original_id || node.foto_versao === null) {
            return;
        }

        this.MeurhOrganogramaService.getTrabalhadoresFoto(node.original_id, node.foto_versao)
            .then((url: string | null) => {
                if (!url || geracaoAtual !== this.geracao) {
                    return;
                }

                node.photo = url;

                if (this.diagram && this.diagram.data && this.diagram.data.getItem(node.id)) {
                    this.diagram.data.update(node.id, { photo: url });
                }
            });
    }

    private marcarAberto(id: string, aberto: boolean): void {
        const node = this.orgData.find((n) => n.id === id);
        if (node) {
            node.open = aberto;
        }
    }
}
